function SparklesIcon(param) {
    var createElement = param.createElement;
    return /*#__PURE__*/ createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 20 20"
    }, /*#__PURE__*/ createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 1.875c.27 0 .51.173.594.43l1.593 4.844a1.043 1.043 0 0 0 .664.664l4.844 1.593a.625.625 0 0 1 0 1.188l-4.844 1.593a1.043 1.043 0 0 0-.664.664l-1.593 4.844a.625.625 0 0 1-1.188 0l-1.593-4.844a1.042 1.042 0 0 0-.664-.664l-4.844-1.593a.625.625 0 0 1 0-1.188l4.844-1.593a1.042 1.042 0 0 0 .664-.664l1.593-4.844a.625.625 0 0 1 .594-.43ZM9 7.539A2.292 2.292 0 0 1 7.54 9L4.5 10l3.04 1A2.292 2.292 0 0 1 9 12.46l1 3.04 1-3.04A2.293 2.293 0 0 1 12.46 11l3.04-1-3.04-1A2.292 2.292 0 0 1 11 7.54L10 4.5 9 7.54ZM4.167 1.875c.345 0 .625.28.625.625v3.333a.625.625 0 0 1-1.25 0V2.5c0-.345.28-.625.625-.625ZM15.833 13.542c.345 0 .625.28.625.625V17.5a.625.625 0 1 1-1.25 0v-3.333c0-.345.28-.625.625-.625Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1.875 4.167c0-.346.28-.625.625-.625h3.333a.625.625 0 1 1 0 1.25H2.5a.625.625 0 0 1-.625-.625ZM13.542 15.833c0-.345.28-.625.625-.625H17.5a.625.625 0 0 1 0 1.25h-3.333a.625.625 0 0 1-.625-.625Z",
        clipRule: "evenodd"
    }));
}
function ArrowUpIcon(param) {
    var createElement = param.createElement;
    return /*#__PURE__*/ createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, /*#__PURE__*/ createElement("path", {
        d: "m5 12 7-7 7 7"
    }), /*#__PURE__*/ createElement("path", {
        d: "M12 19V5"
    }));
}
function ArrowRightIcon(param) {
    var createElement = param.createElement;
    return /*#__PURE__*/ createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, /*#__PURE__*/ createElement("path", {
        d: "M5 12h14"
    }), /*#__PURE__*/ createElement("path", {
        d: "m12 5 7 7-7 7"
    }));
}
function ChevronUpIcon(param) {
    var createElement = param.createElement;
    return /*#__PURE__*/ createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, /*#__PURE__*/ createElement("path", {
        d: "m18 15-6-6-6 6"
    }));
}
function ChevronDownIcon(param) {
    var createElement = param.createElement;
    return /*#__PURE__*/ createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, /*#__PURE__*/ createElement("path", {
        d: "m6 9 6 6 6-6"
    }));
}
function CloseIcon(param) {
    var createElement = param.createElement;
    return /*#__PURE__*/ createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, /*#__PURE__*/ createElement("path", {
        d: "M18 6 6 18"
    }), /*#__PURE__*/ createElement("path", {
        d: "m6 6 12 12"
    }));
}
function MaximizeIcon(param) {
    var createElement = param.createElement;
    return /*#__PURE__*/ createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, /*#__PURE__*/ createElement("path", {
        d: "M15 3h6v6"
    }), /*#__PURE__*/ createElement("path", {
        d: "m21 3-7 7"
    }), /*#__PURE__*/ createElement("path", {
        d: "m3 21 7-7"
    }), /*#__PURE__*/ createElement("path", {
        d: "M9 21H3v-6"
    }));
}
function MinimizeIcon(param) {
    var createElement = param.createElement;
    return /*#__PURE__*/ createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, /*#__PURE__*/ createElement("path", {
        d: "m14 10 7-7"
    }), /*#__PURE__*/ createElement("path", {
        d: "M20 10h-6V4"
    }), /*#__PURE__*/ createElement("path", {
        d: "m3 21 7-7"
    }), /*#__PURE__*/ createElement("path", {
        d: "M4 14h6v6"
    }));
}
function StopIcon(param) {
    var createElement = param.createElement;
    return /*#__PURE__*/ createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, /*#__PURE__*/ createElement("circle", {
        cx: "12",
        cy: "12",
        r: "10"
    }), /*#__PURE__*/ createElement("rect", {
        x: "9",
        y: "9",
        width: "6",
        height: "6",
        rx: "1"
    }));
}
function ReloadIcon(param) {
    var createElement = param.createElement;
    return /*#__PURE__*/ createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, /*#__PURE__*/ createElement("path", {
        d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"
    }), /*#__PURE__*/ createElement("path", {
        d: "M21 3v5h-5"
    }), /*#__PURE__*/ createElement("path", {
        d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"
    }), /*#__PURE__*/ createElement("path", {
        d: "M3 21v-5h5"
    }));
}
function CopyIcon(param) {
    var createElement = param.createElement;
    return /*#__PURE__*/ createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, /*#__PURE__*/ createElement("rect", {
        width: "14",
        height: "14",
        x: "8",
        y: "8",
        rx: "2",
        ry: "2"
    }), /*#__PURE__*/ createElement("path", {
        d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"
    }));
}
function MenuIcon(param) {
    var createElement = param.createElement;
    return /*#__PURE__*/ createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, /*#__PURE__*/ createElement("circle", {
        cx: "12",
        cy: "12",
        r: "1"
    }), /*#__PURE__*/ createElement("circle", {
        cx: "12",
        cy: "5",
        r: "1"
    }), /*#__PURE__*/ createElement("circle", {
        cx: "12",
        cy: "19",
        r: "1"
    }));
}
function LoadingSpinnerIcon(param) {
    var createElement = param.createElement;
    return /*#__PURE__*/ createElement("svg", {
        viewBox: "12 12 24 24",
        role: "status",
        "aria-busy": "true",
        "aria-live": "polite"
    }, /*#__PURE__*/ createElement("title", null, "Loading spinner"), /*#__PURE__*/ createElement("circle", {
        cx: "24",
        cy: "24",
        r: "11",
        fill: "none",
        stroke: "currentColor"
    }));
}
function CheckIcon(param) {
    var createElement = param.createElement;
    return /*#__PURE__*/ createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, /*#__PURE__*/ createElement("path", {
        d: "M21.801 10A10 10 0 1 1 17 3.335"
    }), /*#__PURE__*/ createElement("path", {
        d: "m9 11 3 3L22 4"
    }));
}
function ThumbsUpIcon(param) {
    var createElement = param.createElement;
    return /*#__PURE__*/ createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, /*#__PURE__*/ createElement("path", {
        d: "M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z"
    }), /*#__PURE__*/ createElement("path", {
        d: "M7 10v12"
    }));
}
function ThumbsDownIcon(param) {
    var createElement = param.createElement;
    return /*#__PURE__*/ createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, /*#__PURE__*/ createElement("path", {
        d: "M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z"
    }), /*#__PURE__*/ createElement("path", {
        d: "M17 14V2"
    }));
}
function ChevronLeftIcon(param) {
    var createElement = param.createElement;
    return /*#__PURE__*/ createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, /*#__PURE__*/ createElement("path", {
        d: "m15 18-6-6 6-6"
    }));
}
function ChevronRightIcon(param) {
    var createElement = param.createElement;
    return /*#__PURE__*/ createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, /*#__PURE__*/ createElement("path", {
        d: "m9 18 6-6-6-6"
    }));
}

export { ArrowRightIcon, ArrowUpIcon, CheckIcon, ChevronDownIcon, ChevronLeftIcon, ChevronRightIcon, ChevronUpIcon, CloseIcon, CopyIcon, LoadingSpinnerIcon, MaximizeIcon, MenuIcon, MinimizeIcon, ReloadIcon, SparklesIcon, StopIcon, ThumbsDownIcon, ThumbsUpIcon };
